import React from 'react';
import bn from 'utils/bemnames';
import { Navbar, Nav, Button, } from 'reactstrap';
import { MdClearAll, MdExitToApp, } from 'react-icons/lib/md';
import * as loginActions from '../../store/login/actions';
import * as loginSelectors from '../../store/login/reducer';
import { connect } from 'react-redux';

const bem = bn.create('header');

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
  }
  logout() {
    this.props.dispatch(loginActions.logout());
  }
  state = {
    isOpenNotificationPopover: false,
  };
  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });
  };
  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();
    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };
  render() {
    return (
      <Navbar light expand className={bem.b('bg-white')}>
        <Nav navbar className="mr-2">
          <Button outline onClick={this.handleSidebarControlButton}>
            <MdClearAll size={25} />
          </Button>
        </Nav>
        <Nav navbar className={bem.e('nav-right')}>
          <Button outline className="mr-3" onClick={this.logout}><MdExitToApp size={25}/> Logout</Button>
        </Nav>
      </Navbar>
    );
  }
}

// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
  return {
    user : loginSelectors.getUser(state)
  };
}
export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Layout/Header.js